var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 19C22 20.1046 21.1046 21 20 21H4C3.46957 21 2.96086 20.7893 2.58579 20.4142C2.21072 20.0391 2 19.5304 2 19V13.5V5C2 3.89543 2.89543 3 4 3H10.5C11.2575 3 11.9501 3.428 12.2889 4.10557L13.2361 6H13.5H20C21.1046 6 22 6.89543 22 8V19ZM11 6L10.5 5H6H4V6H11ZM4 8V13.5V17V19H6H18H20V17V10V8H18H13.5H12.618H4ZM15.0892 10.692C15.5354 11.0174 15.6334 11.6429 15.308 12.0892L12.3913 16.0892C12.2072 16.3417 11.9156 16.4936 11.6031 16.4998C11.2907 16.506 10.9933 16.3657 10.7993 16.1207L9.21596 14.1207C8.87315 13.6877 8.94628 13.0588 9.3793 12.716C9.81231 12.3731 10.4412 12.4463 10.784 12.8793L11.5506 13.8476L13.692 10.9108C14.0174 10.4646 14.6429 10.3666 15.0892 10.692Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderCheck);
export default __webpack_public_path__ + "static/media/folder_check.65609fbb94350c974f2da731d37bddce.svg";
export { ForwardRef as ReactComponent };